import { Modal, PrimaryButton, PrimaryCardButton, TextArea } from '@cb/apricot-react';
import { Grid } from '@mui/material';
import { ChangeEvent, FC, useEffect, useState } from 'react';

import { Checkbox } from 'src/components';
import { useToasts } from 'src/hooks';
import { ISummary } from 'src/types';
import { useAuth } from 'src/contexts';
import { statusUpdate } from '../../../services/schoolRequest';
import { CircularProgress } from '@mui/material';

export interface INeedMoreInfoSubmitForm {
  comment: string;
  requireTestingPlan: boolean;
}

export interface NeedMoreInfoModalProps {
  isOpen?: boolean;
  request: ISummary | null;
  onClose: VoidFunction;
  onComplete: (request: ISummary) => void;
}

const NeedMoreInfoModal: FC<NeedMoreInfoModalProps> = ({ isOpen, request, onClose, onComplete }) => {

  const { userName } = useAuth();
  const [loading, setLoading] = useState('');
  const [comment, setComment] = useState('');
  const [requireTestingPlan, setRequireTestingPlan] = useState(false);

  const { render: renderToasts, toastErrorMessage } = useToasts();

  const handleChangeStatusComments = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setComment(event.target.value);
  };

  const handleChangeRequireTestingPlan = (checked: boolean) => {
    setRequireTestingPlan(checked);
  };

  const handleSubmit = async () => {
    if (!comment || !request) {
      toastErrorMessage('Incomplete data -- please enter comments for user');
    } else {
      setLoading('Saving');
      toastErrorMessage(null);

      try {
        const updated = await statusUpdate(request.userId, request.categoryId, {
          user: userName,
          status: 'reopen',
          comment: comment,
          requireTestingPlan: requireTestingPlan
        });

        //TODO: export update() method from request service
        request.updateDate = updated.time;
        onComplete(request);
      } catch (error: any) {
        toastErrorMessage(error.message);
      }
      setLoading('');
    }
  };

  useEffect(() => {
    setComment('');
    setRequireTestingPlan(false);
  }, [isOpen]);

  return (
    // @ts-ignore
    <Modal
      title="Additional Information Required"
      actions={[
        <PrimaryButton key="submit" onClick={handleSubmit} disabled={loading ? true : false}>
          Confirm
        </PrimaryButton>,
        <PrimaryCardButton key="close" onClick={onClose} disabled={loading ? true : false}>
          Close
        </PrimaryCardButton>
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {renderToasts()}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextArea onChange={handleChangeStatusComments} value={comment} maxLength={5000} />
        </Grid>

        <Grid item xs={12}>
          <Checkbox
            key="require-testing-plan"
            checked={requireTestingPlan}
            label="Request the submitter to fill out the testing plan"
            onChange={handleChangeRequireTestingPlan}
          />
        </Grid>
      </Grid>

      {loading &&
        <div style={{ marginTop: '20px' }}>
          <Grid item xs={12}><CircularProgress /> <div style={{ display: 'inline-block', fontSize: '20px' }}>{loading}</div></Grid>
        </div>
      }
    </Modal>
  );
};
export default NeedMoreInfoModal;
